<template>
  <div class="margin-bottom-0">
    <div class="alert alert-danger" role="alert" v-show="message.error">
      {{ message.error }}
    </div>
    <div class="alert alert-success" v-show="message.success">
      <span class="close" data-dismiss="alert">×</span>
      <strong>Success!</strong>
      {{ message.success }}
    </div>
    <div class="form-group m-b-15">
      <input type="text" class="form-control form-control-lg" name="email" id="email" v-model="email" placeholder="Enter your Email" :class="{'is-invalid': $v.email.$error}" @input="$v.email.$touch()" @keyup.enter="ask()"/>
      <div v-if="$v.email.$error" class="invalid-feedback">Email is not valid</div>
    </div>
    <div class="login-buttons">
      <button type="button" class="btn btn-womia btn-block btn-lg" @click.stop.prevent="ask()">Ask</button>
    </div>
    <div class="m-t-20 m-b-40 p-b-40 text-inverse">
      Already have an account? Click <router-link class="text-theme" :to="{ name: 'Login'}">here</router-link> to login.
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'ForgotPassword',
  mixins: [validationMixin],
  validations: {
    email: { required, email }
  },
  data() {
    return {
      email: null,
      message: {
        error: false,
        success: false
      }
    }
  },

  methods: {
    ...Vuex.mapActions(['renewPassword']),
    showErrorMessage(message) {
      this.message.error = message
    },
    showSuccessMessage(message) {
      this.message.error = null
      this.message.success = message
    },
    ask: function() {
      if (!this.$v.email.$invalid) {
        this.renewPassword({ email: this.email })
          .then(() => this.showSuccessMessage('Please check your email address for password reset instructions'))
          .catch(err => {
            let errMsgObj = JSON.parse(err.message)
            if (errMsgObj.message === 'renewPassword.email.notRegistred') {
              errMsgObj.messageText = 'The email address you have entered is not registered'
            } else {
              errMsgObj.messageText = 'Error when asking to change password'
            }
            this.showErrorMessage(errMsgObj.messageText)
          })
      } else {
        this.$v.email.$touch()
        this.showErrorMessage('Form is not valid, check before submit')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/auth/ForgotPassword.vue